module.exports = __webpack_public_path__ + "static/media/showcase3.6aa3261b.png";